export function getNameLabel(category: string) {
  switch (category) {
    case "Properties":
      return "Property address";
    case "Vehicles":
      return "Vehicle description";
    case "Valuables":
    case "Safe or safety deposit box":
      return "Item name";
    case "Life insurance":
    case "Long-term care insurance":
    case "Annuity contracts":
      return "Policy name";
    case "Secured debts":
    case "Unsecured Debts":
      return "Loan name";
    default:
      return "Name";
  }
}

export function getTypeLabel(category: string) {
  switch (category) {
    case "Bank accounts":
    case "Brokerage accounts":
    case "Tax-advantaged savings":
    case "Retirement accounts":
    case "Crypto accounts":
    case "NFTs":
    case "Other digital assets":
      return "Account type";
    case "Properties":
      return "Property type";
    case "Life insurance":
    case "Long-term care insurance":
    case "Annuity contracts":
      return "Policy type";
    case "Valuables":
      return "Item type";
    case "Vehicles":
      return "Vehicle type";
    case "Unsecured Debts":
    case "Secured debts":
      return "Debt type";
    case "Ongoing Estate Expenses":
      return "Expense type";
    default:
      return "Type";
  }
}

export function getValueLabel(category: string) {
  switch (category) {
    case "Bank accounts":
    case "Brokerage accounts":
    case "Tax-advantaged savings":
    case "Retirement accounts":
    case "Crypto accounts":
    case "NFTs":
    case "Other digital assets":
      return "Balance";
    case "Unsecured Debts":
    case "Secured debts":
    case "Contingent Liabilities":
    case "Tax Liabilities":
    case "Ongoing Estate Expenses":
      return "Amount owed";
    case "Properties":
    case "Vehicles":
    case "Valuables":
    case "Safe or safety deposit box":
      return "Estimated value";
    case "Life insurance":
    case "Long-term care insurance":
    case "Annuity contracts":
      return "Death benefit";
    default:
      return "Value";
  }
}

export function getPlaceholder(category: string) {
  switch (category) {
    case "Bank accounts":
      return "e.g., Chase Checking";
    case "Brokerage accounts":
      return "e.g., Schwab Brokerage";
    case "Tax-advantaged savings":
      return "e.g., Fidelity 529 Plan";
    case "Retirement accounts":
      return "e.g., Vanguard 401(k)";
    case "Crypto accounts":
      return "e.g., Coinbase Account";
    case "NFTs":
      return "e.g., CryptoPunk #1234";
    case "Other digital assets":
      return "e.g., Digital asset name";
    case "Properties":
      return "e.g., 123 Main Street, New York, NY";
    case "Life insurance":
      return "e.g., MetLife Term Life Policy";
    case "Long-term care insurance":
      return "e.g., Genworth LTC Policy";
    case "Annuity contracts":
      return "e.g., Pacific Life Annuity";
    case "Vehicles":
      return "e.g., 2022 Tesla Model Y";
    case "Valuables":
      return "e.g., Grandmother's antique brooch";
    case "Unsecured Debts":
      return "e.g., Chase Sapphire Reserve";
    case "Secured debts":
      return "e.g., Primary Residence Mortgage";
    case "Ongoing Estate Expenses":
      return "e.g., Smith Family Funeral Home";
    default:
      return "e.g., Account name";
  }
}

export function formatDisplayValue(val: string) {
  if (!val) return "";
  const num = parseFloat(val);
  if (isNaN(num)) return "";

  const parts = val.split(".");
  const integerPart = parseInt(parts[0]).toLocaleString("en-US");
  const decimalPart = parts[1] !== undefined ? "." + parts[1] : "";

  return integerPart + decimalPart;
}
